import React from 'react'
import { useOutletContext } from 'react-router-dom'
import RoutedMenu from '../../../../RoutedMenu/RoutedMenu'
import useInvoices from './Invoices/useInvoices'

function BillingTab() {
    const {
        affiliate,
        verificationListing,
        partner,
        listing,
        canUpdate,
        canUpdateBillingRules,
        subTab
    } = useOutletContext()

    const items = [
        {
            label: 'Billing Settings',
            to: 'billing-settings',
        }, {
            label: 'Invoices',
            to: 'billing-invoices',
        }, {
            label: 'Current Month',
            to: 'current-month',
        },
    ]

    return (
        <div style={{ margin: '30px 0 0 0' }}>
            <RoutedMenu
                activeTab={subTab}
                items={items}
                context={{
                    affiliate,
                    verificationListing,
                    partner,
                    listing,
                    canUpdate,
                    canUpdateBillingRules,
                    ...useInvoices(),
                }}
            />
        </div>
    )
}

export default BillingTab